import { render, staticRenderFns } from "./TeacherNotificationDetail.vue?vue&type=template&id=6999490d"
import script from "../../services/notification/teacher-notification-detail.js?vue&type=script&lang=js&external"
export * from "../../services/notification/teacher-notification-detail.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/notification/teacher-notification-detail.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports